// API Configuration for Production
export const apiConfig = {
  // NEW Clean API Gateway (production) - Fixed signature validation
  lambdaBackend: 'https://zbxepuqat0.execute-api.eu-west-2.amazonaws.com/prod',
  
  // WebSocket URL for real-time features
  websocketUrl: 'wss://w0q73jayde.execute-api.eu-west-2.amazonaws.com/prod',
  
  // Use Lambda backend
  useLambda: true,
  
  // Base URL: use relative paths via Vercel rewrite to avoid CORS
  baseURL: '/',
  
  // Timeout settings
  timeout: 30000,
  
  // Retry settings
  retryAttempts: 3,
  retryDelay: 1000,
  
  // Environment
  environment: 'production'
};

// Helper function to check if using Lambda backend
export const isUsingLambdaBackend = () => {
  return apiConfig.useLambda;
};

// Export the active configuration
export default apiConfig;